"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("../constant");

var _Banner = _interopRequireDefault(require("../Banner"));

var _constant3 = require("./constant");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var _default = {
  PropTypes: {
    // Contract from Content Service
    bannerDetails: _propTypes.default.arrayOf(_propTypes.default.exact(_objectSpread(_objectSpread({}, _Banner.default.propTypes), {}, {
      headline: _propTypes.default.string,
      subheadline: _propTypes.default.string,
      tags: _propTypes.default.array,
      buttonUrl: _propTypes.default.string,
      buttonText: _propTypes.default.string,
      altText: _propTypes.default.string,
      redirectUrl: _propTypes.default.string,
      desktopImage: _propTypes.default.string.isRequired,
      mobileImage: _propTypes.default.string,
      tabletImage: _propTypes.default.string
    }))).isRequired,
    timer: _propTypes.default.string,
    title: _propTypes.default.string,
    gtmParameters: _propTypes.default.object,
    gtmConsumerName: _propTypes.default.string,
    indexNumber: _propTypes.default.number,
    placeHolderBackground: _propTypes.default.oneOf(_constant.ARR_BACKGROUND_COLORS),
    fireGtm: _propTypes.default.func,
    // Additional Contract
    queryParams: _propTypes.default.object,
    device: _propTypes.default.oneOf(Object.values(_constant2.DEVICE_TYPE)),
    selectedBanner: _propTypes.default.number,
    // index of selected banner
    width: _propTypes.default.string,
    height: _propTypes.default.string,
    withTimer: _propTypes.default.bool,
    pageColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    activePageColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    customProperties: _propTypes.default.object,
    accessible: _propTypes.default.bool,
    theme: _propTypes.default.string,
    mobileViewHeight: _propTypes.default.string,
    alignButtonContainer: _propTypes.default.string,
    alignHeadlineContainer: _propTypes.default.string,
    alignHeadlineVerticalContainer: _propTypes.default.string,
    headlineVerticalContainerTopSpace: _propTypes.default.string,
    headlineVerticalContainerBottomSpace: _propTypes.default.string,
    paginationContainerBottomSpace: _propTypes.default.string,
    onBannerClick: _propTypes.default.func
  },
  DefaultProps: {
    device: _constant2.DEVICE_TYPE.DESKTOP,
    width: _constant3.HERO_BANNER_DEFAULT_WIDTH,
    height: _constant3.HERO_BANNER_DEFAULT_HEIGHT,
    selectedBanner: _constant3.HERO_BANNER_DEFAULT_INDEX,
    withTimer: true,
    timer: _constant3.HERO_BANNER_DEFAULT_TIMER,
    accessible: true,
    theme: _constant.DEFAULT_THEME
  }
};
exports.default = _default;